import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from './utils';
import { FILE_KEY } from './constants';

const BASE_PATHNAME = 'win-module';

export default () => {
  const dataSource = createDataSource(config.api.url);
  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  const create = ({ values }) => dataSource.post(BASE_PATHNAME, { json: { ...values } }).json();
  const update = ({ id, values }) => dataSource.put(`${BASE_PATHNAME}/${id}`, { json: { id, ...values } }).json();

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      defaultFilters: { sort: 'startDate' },
    }),
    getById,
    create,
    update,
    getEmptyList: getDefaultEmptyList,
  };
};
